import { useEffect } from "react";

import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { refreshTags } from "./useVatRateCount";
import { FormDataType } from "./useVatRateCount";

export function useRefreshTags(
    dataVatRate: any,
    userID: any,
    franchiseID: any,
    setTagsVateRate: (val: string[]) => void,
    formTags: string[],
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    useEffect(() => {
        refreshTags(
            userID,
            franchiseID,
            setTagsVateRate,
            formTags,
            fetchGlobal
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataVatRate, userID, franchiseID]);
}

export function useResetErrorsOnEdit(
    isAddVatRateClicked: boolean,
    dataVatRate: any,
    isEditMode: boolean,
    resetErrors: () => void
) {
    useEffect(() => {
        if (isEditMode) resetErrors();
    }, [isAddVatRateClicked, dataVatRate, isEditMode, resetErrors]);
}

export function useCleanFormOnNewClick(
    isAddNewVatRateButtonClicked: boolean,
    cleanForm: () => void
) {
    useEffect(() => {
        cleanForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAddNewVatRateButtonClicked]);
}

export function useInitVatRateFormData(
    dataVatRate: any,
    oneShop: boolean,
    t: (key: string) => string,
    modalsAssociation: boolean,
    confirmationArchivedExistMessageClick: boolean,
    setForm: (val: FormDataType) => void,
    setType: (val: "add" | "update" | "updateShop") => void,
    setCanValidate: (val: boolean) => void,
    cleanForm: () => void
) {
    useEffect(() => {
        if (dataVatRate?.selectedRow?.Id !== undefined) {
            const row = dataVatRate.selectedRow;
            setForm({
                code: row.code.replace(",", "."),
                value: row.value.replace(",", "."),
                tags: row.tag,
                paysData: row[t("Country")]?.labels || [],
            });
            clearData();
            clearMultiCustomSelectionData();
            setType(oneShop ? "updateShop" : "update");
            setCanValidate(false);
        } else if (
            !modalsAssociation &&
            !confirmationArchivedExistMessageClick
        ) {
            cleanForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dataVatRate,
        oneShop,
        t,
        modalsAssociation,
        confirmationArchivedExistMessageClick,
    ]);
}
